import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import classNames from 'classnames';

import { gtmActions } from '../state/gtm.js';

export const PopularDestinations = props => {
    const trackClick = (name, index) => {
        props.dispatch(gtmActions.clickDestination({ name, index }));
    };

    const renderLocation = index => {
        const values = props.t(`destinations.values.n${index}`, { returnObjects: true });
        const key = `seoDestination${index}`;

        return (
            <div
                key={key}
                data-testid={key}
                className={classNames('grid__unit', 'u-ma4', { 'u-hide-lt640': index >= 3 && index < 6, 'u-hide-lt900': index >= 6 })}
                style={{ width: 'auto' }}
                onClick={() => trackClick(values.name, index)}>
                <a href={FINN.travel.contextPath + values.iata} className="img">
                    <img
                        src={`${FINN.travel.cdnBaseUrl}${FINN.travel.contextPath}assets/img/popular_destinations/${values.img}`}
                        height="57"
                        alt={values.alt}
                    />
                    <p className="u-mh0 u-mt4">{values.name}</p>
                </a>
            </div>
        );
    };

    return FINN?.travel?.enableSeo ? null : (
        <div className="panel u-mb32">
            <h2 className="u-t3">{props.t('destinations.title')}:</h2>
            <div className="grid u-d1">{[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(renderLocation)}</div>
        </div>
    );
};

PopularDestinations.propTypes = {
    dispatch: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default connect()(withTranslation('search')(memo(PopularDestinations)));
